export const clearOidcLocalStorage = () => {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key?.startsWith('oidc.') === true) {
      localStorage.removeItem(key);
    }
  }
};
